import { __extends } from "tslib";
import React from 'react';
import withSortedPageRows from '../hoc/withSortedPageRows';
import TableRow from './TableRow';
var Body = /** @class */ (function (_super) {
    __extends(Body, _super);
    function Body() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Body.prototype.render = function () {
        var _a = this.props, pageRows = _a.pageRows, head = _a.head, isFixedSize = _a.isFixedSize, highlightedRowIndex = _a.highlightedRowIndex, testId = _a.testId;
        return (React.createElement("tbody", { "data-testid": testId && testId + "--body" }, pageRows.map(function (row, rowIndex) { return (React.createElement(TableRow, { head: head, isFixedSize: isFixedSize, key: row.key || rowIndex, row: row, isHighlighted: highlightedRowIndex === rowIndex, testId: testId })); })));
    };
    return Body;
}(React.Component));
export default withSortedPageRows(Body);
//# sourceMappingURL=Body.js.map